import {SlidingPanel} from '../commons/layout/sliding-panel';
import { init as initAccountProfileHomeAddress, reloadHomeAddressForm } from '@/customer/account/account-profile-home-address';
/**
 * Created by dev on 6/30/17.
 */
var $ = window.$;

var actors = {
    BOOK_ORDER_SERVICE: '/rest/model/com/decathlon/cube/commerce/order/sap/BookingActor/bookOrder',
    ADDRESS_BOOK_SERVICE: '/rest/model/atg/userprofiling/ProfileActor/getAddressBook',
    PROVINCE_GEO_DATA_SERVICE: '/rest/model/com/decathlon/cube/geodata/actor/GeoDataActor/getGeoDataRelatedToId',
    HK_GEO_DATA_ATTRIBUTES: '?geoDataType=PROVINCE&geoDataId=HKG',
    GET_CITIES: 'rest/model/com/decathlon/cube/geodata/actor/GeoDataActor/getGeoDataByCountryCodeAndPostalCode'
};


var addresses = [];
var provinces = [];

export function init () {
    var modifyAddressButton = document.getElementById('dkt-billing-address-modify');
    if (modifyAddressButton) {
        modifyAddressButton.addEventListener('click', function () {
            modifyBillingAddress();
        });
    }
    reloadDisplayBillingComponent();
};


cube.event.on('reinit-checkout-billing-address', init);

var Address = function (item) {
    this.postalCode = item.postalCode;
    this.streetName = item.streetName;
    this.streetNumber = item.streetNumber;
    this.country = item.country;
    this.city = item.city;
    this.title = item.title || Messages('payment.message.billingAddress.title.default');

    // HK
    this.province = item.province;
    this.line1 = item.line1;
    this.street = item.line2;
};

var Province = function (item) {
	this.id = item.id;
	this.label = item.label;
};

var billingAddressSpecifics = function () {
    const $billing = $('#billing-address-content');
    $billing.find('#updateHomeAddress').remove();
    $billing.find('#editHomeAddress').remove();
    $billing.find('#homeAddressData h3').remove();
};

var reloadDisplayBillingComponent = function () {
    const cartridge = cube.cartridge('display-billing-address');
    cartridge.after(billingAddressSpecifics);
    cartridge.reload();
};

var addressBookEvents = function () {
    $('#address-book').on('changed.bs.select', function (event) {
        addresses.forEach(function (address) {
            if (address.title === event.target.value) {
                $('#postalCode').val(address.postalCode);
                $('#streetNumber').val(address.streetNumber);
                $('#streetName').val(address.streetName);

                var cityInput = cube.$id('city');
                if(cityInput !== null) {
                    cityInput.value = address.city;
                    fetchCity();
                }

                var postalCode = cube.$id('postalCode');
                if(postalCode) {
                  postalCode.dispatchEvent(new InputEvent('change'));
                }

                //HK
                $('#line1').val(address.line1);
                $('#line2').val(address.street);

                var province = provinces.filter(function(province){
                    return province.label === address.province;
                });

                if(province.length > 0)
                    $('#provinceGeoId').selectpicker('val', province[0].id);
            }
        })
    });
};


var provinceEvents = function () {
	$("ul.dropdown-menu li").click(function () {
		var provinceLabel = $(this).find('span').text();
		$('#provinces-select').attr("title",provinceLabel);
		$('#provinceGeoId').find("[selected='true']").removeAttr('selected');
		$('#provinceGeoId').find("[selected='selected']").removeAttr('selected');

		$('#provinceGeoId').find("option:contains('"+provinceLabel+"')").attr("selected","true");
		var button = $('#provinceGeoId').next().find("[data-id='provinceGeoId']");
		if (button){
			button.attr("title",provinceLabel);
			$('span:first',button).text(provinceLabel);
		}

		$('#provinceGeoId').selectpicker('refresh');

    });
};

var displayProvinces = function () {
	var options = '';
    var provinceSelect = cube.$id('provinceGeoId');

	provinces.forEach(function (province) {
		options += '<option value ="'+ province.id +'">'+province.label+'</option>';
	});

    provinceSelect.innerHTML = options;
    $('#provinceGeoId').selectpicker('refresh');

    var $countryCodeGeoId = $('#countryCodeGeoId');

    if ($countryCodeGeoId.length) {
      cube.form.address.init($countryCodeGeoId.val(), 'BILLING');

      $countryCodeGeoId.on('change', function () {
        cube.form.address.init($countryCodeGeoId.val(), 'BILLING');
      });
    }

    provinceEvents();
}

var displayAddressBook = function () {
    var addressBookSelect = document.createElement('select');
    addressBookSelect.className = 'selectpicker';
    addressBookSelect.id = 'address-book';
    var selectOption = document.createElement('option');
    selectOption.innerText = Messages('billingAddress.select');
    addressBookSelect.appendChild(selectOption);
    if(addresses.length > 0) {
      [].forEach.call(addresses, function(address) {
        var option = document.createElement('option');
        option.value = address.title;
        option.innerText = address.title;
        option.setAttribute('data-tnr-billing-home-address', ''); // NRT
        addressBookSelect.appendChild(option);
      });
      cube.$id('select-billing-address').appendChild(addressBookSelect);
    } else {
      cube.$id('select-billing-address').classList.add('hidden');
      cube.$id('address-selector-separator').classList.add('hidden');
    }
    addressBookEvents();
    provinces = [];
};

var handleAddressBookResponse = function ($this, response) {
    const data = response.responseTO.data.address;
    addresses = [];
    data.forEach(function (item) {
        addresses.push(new Address(item));
    });
    displayAddressBook();
};

var handleProvinceGeoDataResponse = function ($this, response) {
    const data = response.responseTO.data;

    data.forEach(function (item) {
        provinces.push(new Province(item));
    });
    if (provinces.length > 0){
    	displayProvinces();
    }
};

var reloadAddressBook = function () {
    getAjaxHandler()
        .withUrl(actors.ADDRESS_BOOK_SERVICE)
        .withSuccess(handleAddressBookResponse)
        .call();
};

var loadProvinceGeoData = function (){
	getAjaxHandler()
		.withUrl(actors.PROVINCE_GEO_DATA_SERVICE + actors.HK_GEO_DATA_ATTRIBUTES)
		.withSuccess(handleProvinceGeoDataResponse)
		.call();
}

var fetchCity = function(event) {
    var postalCodeInput = cube.$id('postalCode');
    var postalCodeValue = event !== undefined ? event.target.value : postalCodeInput.value;
    if(postalCodeInput !== null)
        postalCodeInput.disabled = true;
    cube.ajax.get(actors.GET_CITIES + '?postalCode=' + postalCodeValue + '&countryID=' + cube.$id('countryCodeGeoId').value)
        .onSuccess(function(response) {
            if(postalCodeInput !== null)
                postalCodeInput.disabled = false;
            if(response.responseTO && response.responseTO.data) {
                var cityPicker = $('#cityGeoId');
                var citySelect = document.querySelector('.selectpicker.geodata');
                var cities = response.responseTO.data;

                if(citySelect !== null) {
                    citySelect.innerHTML = '';
                    [].forEach.call(cities, function(city) {
                        var option = document.createElement('option');
                        option.value = city.id;
                        option.innerText = city.label;

                        citySelect.appendChild(option);
                    });

                    cityPicker.selectpicker('refresh');
                }
            }
        })
        .onError(function (response) {
          if(postalCodeInput !== null)
            postalCodeInput.disabled = false;
        })
        .call();
}

var modifyBillingAddress = function () {
    const content =
    `<div id="select-billing-address" data-tnr-select-billing-address></div>
        <span id="address-selector-separator">${Messages('or')}</span>
        <div id="modify-billing-address" data-t-path="ac_homeaddress" data-t-url="content/Shared/Account/My Home Address Core/My Home Address Core"></div>`;

    var panel = new SlidingPanel();
    panel.init({
        parent: module,
        content: content,
        title: Messages('BUY.billingAddress.payment.edit'),
        name: 'change-billing-address-panel'
    });
    const cartridge = cube.cartridge('modify-billing-address');
    cartridge.after(function () {
        $('.selectpicker').selectpicker('render');

        var postalCode = document.getElementById('postalCode');
        if (document.getElementById('dkt-payment-kit')) {
          const isWidgetHiddenInput = document.createElement('input');
          isWidgetHiddenInput.value = window.tc_vars.order_id;
          isWidgetHiddenInput.type = 'hidden';
          isWidgetHiddenInput.name = 'orderId';
          document.getElementById('address-form').prepend(isWidgetHiddenInput);
        }
        var typingTimer;
        if (postalCode != null){
            postalCode.addEventListener('input', function (e) {
                clearTimeout(typingTimer);
                typingTimer = setTimeout(function() { fetchCity(e) }, 500);
            });

            postalCode.addEventListener('keydown', function (e) {
                clearTimeout(typingTimer);
            });

            postalCode.addEventListener('change', fetchCity);

            var $countryCodeGeoId = $('#countryCodeGeoId');

            $countryCodeGeoId.on('changed.bs.select', function () {
                fetchCity();
            });
        }

        const $addInAddressBookCheckbox = $("#addInAddressBookCheckbox");
        $addInAddressBookCheckbox.remove();
        $('#cancelHomeAddressForm').remove();
        loadProvinceGeoData();

        var form = cube.$id('address-form');
        var submit = form.$class('submit-button')[0];

        initAccountProfileHomeAddress(form.id);

        submit.addEventListener('click', function (e) {
          e.preventDefault();

          // Quick fix : Useless fields are displayed in billing address, they are hidden but checked,
          // I deleted them.
          var billingUselessFields = document.getElementById('complementary-fields');
          if(billingUselessFields)
            billingUselessFields.parentNode.removeChild(billingUselessFields);

          reloadHomeAddressForm(form, () => {
            panel.close();
            billingAddressSpecifics();
            var $billing = $('#change-billing-address-panel');
            $billing.find('#updateHomeAddress').remove();
            $billing.find('#homeAddress').remove();
            var oParametre = {};
            oParametre["orderId"] = window.tc_vars.order_id;
            cube.cartridge('checkout-order-summary')
              .after(function () {
                // reinit billing address button and pay button //
                cube.event.send('reinit-checkout-billing-address');
              })
              .reload(oParametre);
          });
        });
    });
    cartridge.reload();
    reloadAddressBook();
};



// WEBPACK FOOTER //
// ./src/modules-es5/checkout/billingAddress.js